import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://makeupbrushbasics.com";
const DEFAULT_OG = `${SITE}/images/og-default.jpg`;

/**
 * SEO — drop-in <Helmet> wrapper for every page.
 *
 * Props:
 *   title       — page title; will be suffixed with " · BrushBasics" if not present
 *   description — 150-160 char meta description
 *   path        — pathname for canonical/og:url (e.g. "/brush/powder-brush")
 *   image       — absolute image URL for OG/Twitter (defaults to brand OG card)
 *   noindex     — set true on admin/utility pages
 */
export default function SEO({
  title,
  description,
  path = "/",
  image = DEFAULT_OG,
  noindex = false,
}) {
  const fullTitle = /BrushBasics/i.test(title) ? title : `${title} · BrushBasics`;
  const url = `${SITE}${path.startsWith("/") ? path : `/${path}`}`;
  const desc = (description || "").slice(0, 200);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BrushBasics" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
